<template>
  <div class="tab-loading">
    <div class="tab-loading__tab">
      <van-skeleton :row="1" :row-width="60" />
      <van-skeleton :row="1" :row-width="60" />
      <van-skeleton :row="1" :row-width="60" />
    </div>
    <div class="tab-loading__content">
      <van-skeleton :row="10" />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.tab-loading {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #fff;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin-top: 8px;
  &__tab {
    display: flex;
    flex-direction: row;
    padding: 14px;
    border-bottom: 1px solid #e5e6eb;
    flex: 0 0 auto;
    :deep(.van-skeleton) {
      padding: 0 16px 0 0;
    }
  }
  &__content {
    padding-top: 16px;
    flex: 1;
  }
}
</style>
